import { Box } from "@mui/material";
import { OverlayView, type OverlayViewProps } from "@react-google-maps/api";

interface GoogleMapCustomMarkerWrapperProps extends Pick<OverlayViewProps, "position"> {
  children: React.ReactNode;
}

export function GoogleMapCustomMarkerWrapper(props: GoogleMapCustomMarkerWrapperProps) {
  const { children, ...restProps } = props;

  return (
    <OverlayView mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET} {...restProps}>
      <Box
        // this transform is needed to properly position marker on the map
        sx={{ transform: "translate(-50%, -100%)", width: "fit-content", height: "fit-content" }}
      >
        {children}
      </Box>
    </OverlayView>
  );
}
